import { render, staticRenderFns } from "./SparePartCategory.vue?vue&type=template&id=c4e0d6d8"
import script from "./SparePartCategory.vue?vue&type=script&lang=ts"
export * from "./SparePartCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports